import { render, staticRenderFns } from "./commercialeDirettoreDistributoreDettaglio.vue?vue&type=template&id=6a47cb97&"
import script from "./commercialeDirettoreDistributoreDettaglio.vue.ts?vue&type=script&lang=ts&"
export * from "./commercialeDirettoreDistributoreDettaglio.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports